import { BadgeColorVariant } from '@sharedCR/coreDesignSystem/BadgeCDS/BadgeCDS.constants';

export const WireConfirmationStatus = {
  PENDING: 0,
  CONFIRMED: 1,
  REJECTED: 2,
};

export const WireConfirmationBadgeLabel = {
  [WireConfirmationStatus.PENDING]: 'Wire Info Pending',
  [WireConfirmationStatus.CONFIRMED]: 'Wire Info Confirmed',
  [WireConfirmationStatus.REJECTED]: 'Wire Info Rejected',
};

export const WireConfirmationBadgeColor = {
  [WireConfirmationStatus.PENDING]: BadgeColorVariant.ORANGE,
  [WireConfirmationStatus.CONFIRMED]: BadgeColorVariant.GREEN,
  [WireConfirmationStatus.REJECTED]: BadgeColorVariant.RED,
};
